const flowTypeDisplayNames: Record<string, string> = {
  // Estos son los nombres de los flujos que se mostrarán en la interfaz de usuario.
  ESS: 'ESS',
  ESMR: 'ESMR',
  SR: 'Supervision Report',
  SR_ESPF: 'Supervision Report',
  INITIAL_ESRS: 'Initial ESRS',
  ESRS: 'ESRS',
};

export const getFlowTypeDisplayName = (flowType: string | null | undefined): string => {
  if (!flowType) {
    // Si flowType es null, undefined, o una cadena vacía, retorna ''.
    return '';
  }

  const displayName = flowTypeDisplayNames[flowType];

  // Comprueba si displayName es null o undefined.
  // Si NO lo es, devuelve displayName. Si SÍ lo es, devuelve el mismo flowType.
  return displayName !== null && displayName !== undefined ? displayName : flowType;
};

export default getFlowTypeDisplayName;
